import type { DisplayTemplateSource, GaiaClientFunction } from '@/client/types';

/** Temporary cutover header; delete with UX-4500 when UXDS is the only source. */
// MUST match bff/constants/display-template-source.go:DisplayTemplateSourceHeader
export const DISPLAY_TEMPLATE_SOURCE_HEADER = 'X-Display-Template-Source';
// MUST match bff/constants/display-template-source.go:DisplayTemplateSourceS3 / DisplayTemplateSourceUXDS
export const DISPLAY_TEMPLATE_SOURCE_S3: DisplayTemplateSource = 's3';
export const DISPLAY_TEMPLATE_SOURCE_UXDS: DisplayTemplateSource = 'uxds';

export const DISPLAY_TEMPLATE_SOURCES: DisplayTemplateSource[] = [
  DISPLAY_TEMPLATE_SOURCE_UXDS,
  DISPLAY_TEMPLATE_SOURCE_S3,
];

/** Last segment of enhanced-device query keys while UX-4500 cutover lives. */
export function displayTemplateSourceKey(client: GaiaClientFunction): string {
  return client.displayTemplateSource ?? DISPLAY_TEMPLATE_SOURCE_S3;
}

/** Maps ux-config + optional session override to the display-template source. */
export function resolveDisplayTemplateSource(
  uxConfigEnabled: boolean,
  override: DisplayTemplateSource | null = null
): DisplayTemplateSource {
  return override ?? (uxConfigEnabled ? DISPLAY_TEMPLATE_SOURCE_UXDS : DISPLAY_TEMPLATE_SOURCE_S3);
}
